<template>
  <v-checkbox
    v-if="['checkbox', 'boolean', 'v-checkbox'].includes(typeInput)"
    v-model="item"
    v-bind="attrBind"
    class=" ma-0 pa-0"
    v-on="$listeners"
  ></v-checkbox>
  <v-text-field
    v-else-if="['number'].includes(typeInput)"
    v-model="item"
    type="number"
    v-bind="attrBind"
    class=" ma-0 pa-0"
    v-on="$listeners"
  ></v-text-field>

  <component
    v-bind:is="typeInput"
    v-else
    v-model="item"
    v-bind="attrBind"
    class=""
    v-on="$listeners"
  >
    <template v-for="slot in slots" v-slot:[slot]>
      <slot :name="slot" />
    </template>
  </component>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import asyncComponent from '../async'
import FieldMixin from './field-mixin'
function asyncget(field) {
  return asyncComponent(
    import(
      /* webpackChunkName: "field-async-" */ `@components/field/${field}.vue`
    )
  )
}
export default {
  components: {
    FieldColorPicker: () => asyncget('field-color-picker'),
    FieldFileViewInput: () => asyncget('field-file-view-input'),
    FieldDate: () => asyncget('field-date'),
    FieldDateFormat: () => asyncget('field-date-format'),
    FieldFileInput: () => asyncget('field-file-input'),
    FieldGroupList: () => asyncget('field-group-list'),
    FieldGroupTrans: () => asyncget('field-group-trans'),
    FieldSearchSelect: () => asyncget('field-search-select'),
    FieldImageInput: () => asyncget('field-image-input'),
  },
  mixins: [FieldMixin],
  props: {},
  computed: {
    slots() {
      return Object.keys(this.$scopedSlots)
    },
  },
  methods: {},
}
</script>

<style></style>
